import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import './Login.css';
import auth from '../AuthService';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [hasCheckedLogin, setHasCheckedLogin] = useState(false);

  // Check if already logged in on mount
  useEffect(() => {
    if (!hasCheckedLogin && auth.loggedIn()) {
      console.log('User already logged in, redirecting in useEffect');
      try {
        window.location.replace('/');
      } catch (err) {
        console.error('Navigation failed in useEffect:', err);
        window.location.replace('/');
      }
      setHasCheckedLogin(true); // Prevent re-running
    }
  }, [hasCheckedLogin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await auth.login(username, password);

      if (res.twoFARequired) {
        auth.setTempToken(res.tempToken);
        if (res.setupRequired) {
          sessionStorage.setItem('twoSetupSecret', res.secret || '');
          sessionStorage.setItem('twoSetupQr', res.qrCode || '');
          window.location.replace('/setup-2fa');
        } else {
          window.location.replace('/verify-2fa');
        }
      } else {
        navigate('/');
      }
    } catch (err) {
      alert(err.message || 'Login failed');
    }
  };

  // If logged in after checking, redirect
  if (hasCheckedLogin && auth.loggedIn()) {
    console.log('Rendering Navigate to /');
    return <Navigate to="/" replace />;
  }

  return (
    <div className="center">
      <div className="card">
        <h1>Login</h1>
        <form onSubmit={handleSubmit}>
          <input
            className="form-item"
            placeholder="Username..."
            name="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            className="form-item"
            placeholder="Password..."
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input className="form-submit" value="SUBMIT" type="submit" />
        </form>
      </div>
    </div>
  );
}